import client from "../../../api/client";

export default async function getNeighbourhoods(cityId) {
  const config = cityId
    ? {
        params: {
          city_id: cityId,
        },
      }
    : {};

  const response = await client.get("/master/neighbourhoods", config);
  return response.data;
}